import React from 'react';

const LinkedInIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="LinkedIn logo"
    {...props}
  >
    <rect width="24" height="24" rx="4" fill="#0A66C2" />
    <path
      d="M7.5 9.5H5V19H7.5V9.5ZM6.25 8.5C7.08 8.5 7.75 7.83 7.75 7C7.75 6.17 7.08 5.5 6.25 5.5C5.42 5.5 4.75 6.17 4.75 7C4.75 7.83 5.42 8.5 6.25 8.5Z"
      fill="white"
    />
    <path
      d="M13 13.5C13 12.4 13.9 11.5 15 11.5C16.1 11.5 17 12.4 17 13.5V19H19.5V13.5C19.5 11.01 17.49 9 15 9C13.9 9 12.9 9.4 12.1 10.06L12 9.5H9.5V19H12L13 13.5Z"
      fill="white"
    />
  </svg>
);

export default LinkedInIcon;
